import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useFacetData } from '~/context/common/FacetDataContext';
import { Label } from './FiltersMenu.styles';
import useRangeUpdater from './hooks/useRangeUpdater';
import InputRangeSlider from './InputRangeSlider';

export default function Year() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const { min: facetDataMin, max: facetDataMax } = facetData.year ?? {};
  const { min: appliedFiltersMin, max: appliedFiltersMax } =
    appliedFilters.year ?? {};
  const [rangeValues, setRangeValues] = useState([
    appliedFiltersMin ?? facetDataMin ?? 0,
    appliedFiltersMax ?? facetDataMax ?? 0
  ]);

  const onUpdate = useRangeUpdater({
    filterKey: 'year',
    max: facetDataMax,
    min: facetDataMin
  });

  useSubsequentEffect(() => {
    setRangeValues([
      appliedFiltersMin ?? facetDataMin ?? 0,
      appliedFiltersMax ?? facetDataMax ?? 0
    ]);
  }, [appliedFiltersMax, appliedFiltersMin, facetDataMax, facetDataMin]);

  return (
    <>
      <Label>Year</Label>
      <InputRangeSlider
        data-analytics-id="adjust-mpg-range"
        format="years"
        idPrefix="year"
        min={facetDataMin}
        max={facetDataMax}
        thumbBehavior="slide-through"
        value={rangeValues}
        onValueChange={value => {
          setRangeValues(value);
        }}
        onValueCommit={value => {
          onUpdate(value);
        }}
      />
    </>
  );
}
